import { useState } from 'react';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';

type OpenTransactionModalInput = {
  accountId?: number | null;
  includingOpeningBalance?: boolean;
  startDate?: number;
  endDate?: number;
};

type TransactionModalState = {
  open: boolean;
  accountId: number | null;
  includingOpeningBalance: boolean;
  startDate: number | null;
  endDate: number | null;
};

const useTransactionModalHandle = () => {
  const initialState: TransactionModalState = {
    open: false,
    accountId: null,
    includingOpeningBalance: true,
    startDate: null,
    endDate: null,
  };

  const [transactionModalParams, setTransactionModal] = useState<TransactionModalState>(initialState);

  const openTransactionModal = (params?: OpenTransactionModalInput) => {
    console.log({ params });
    // Validation: Check if accountId is a valid number
    if (params?.accountId && (isNaN(Number(params.accountId)) || Number(params.accountId) <= 0)) {
      showWarningSnackbar('Invalid account');
      return;
    }

    // Validation: If startDate is provided, endDate is mandatory
    if (params?.startDate && !params?.endDate) {
      showWarningSnackbar('End date is mandatory when start date is provided');
      return;
    }

    // Validation: If endDate is provided, startDate is mandatory
    if (params?.endDate && !params?.startDate) {
      showWarningSnackbar('Start date is mandatory when end date is provided');
      return;
    }

    setTransactionModal({
      open: true,
      accountId: Number(params?.accountId) ?? null,
      includingOpeningBalance: params?.includingOpeningBalance ? true : false,
      startDate: params?.startDate ?? null,
      endDate: params?.endDate ?? null,
    });
  };

  const closeTransactionModal = () => {
    setTransactionModal(initialState);
  };

  return {
    transactionModalParams: { ...transactionModalParams, onClose: closeTransactionModal },
    openTransactionModal,
  };
};

export { useTransactionModalHandle, type OpenTransactionModalInput };
